'use client';
import CloseIcon from '@repo/ui/src/components/Icons/CloseIcon';
import LeftArrow from '@repo/ui/src/components/Icons/LeftArrow';
import { useDrawer } from '@repo/ui/src/modules/UI/hooks/useDrawer';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  title?: string;
}

export const DrawerHeader = ({ title }: Props) => {
  const { close, closeAll, id, inDrawer, index } = useDrawer();

  const showCloseArrow = index > 0;

  return (
    <div
      className={classNames(
        'tw-mx-auto tw-max-w-3xl tw-w-full tw-grid tw-mb-10 sm:tw-mb-0 tw-bg-surface-100 sm:tw-bg-transparent tw-shadow-drawerHeader sm:tw-shadow-none',
        showCloseArrow ? 'tw-grid-cols-[auto_1fr_auto]' : 'tw-grid-cols-[1fr_auto]',
      )}
    >
      {inDrawer && showCloseArrow && (
        <button
          onClick={close}
          aria-label="Close"
          className="tw-p-6 tw-bg-surface-200 tw-z-10 tw-max-h-20 tra-btn-bare"
        >
          <LeftArrow />
        </button>
      )}
      <div className="tw-p-6 sm:tw-px-16 sm:tw-pt-14 sm:tw-pb-8">
        <h1 className="tra-text-web-heading-4 tw-w-full tw-mb-0" id={`${id}-drawer-title`}>
          {title}
        </h1>
      </div>
      {inDrawer && (
        <button
          onClick={closeAll}
          aria-label="Close"
          className="tw-p-6 tw-bg-surface-300 tw-z-10 tw-max-h-20 tra-btn-bare"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
};
